import TextClamp from './TextClamp';

export default TextClamp;
